import { _stringEnumKeyOrUndefined } from '@naturalcycles/js-lib'
import { SiteLocale, SupportedLocale, SupportedUrl } from '@src/cnst/translations.cnst'

export function toSupportedUrl(locale: SiteLocale | SupportedLocale): SupportedUrl {
  const localeKey =
    _stringEnumKeyOrUndefined(SupportedLocale, locale) ||
    _stringEnumKeyOrUndefined(SiteLocale, locale)
  if (!localeKey) {
    return SupportedUrl.enUS // Default to enUS if not found
  }

  return SupportedUrl[localeKey]
}

export function withSupportedUrl(
  relativePath: string,
  locale: SiteLocale | SupportedLocale,
): string {
  const localeUrlSlug = toSupportedUrl(locale)
  const url = [localeUrlSlug, ...relativePath.split('/').filter(Boolean)].join('/')
  if (!url.startsWith('/')) {
    return '/' + url
  }
  return url
}
